import { render, staticRenderFns } from "./customerPrestockLog.vue?vue&type=template&id=d1fab1a2&scoped=true&"
import script from "./customerPrestockLog.vue?vue&type=script&lang=js&"
export * from "./customerPrestockLog.vue?vue&type=script&lang=js&"
import style0 from "./customerPrestockLog.vue?vue&type=style&index=0&id=d1fab1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fab1a2",
  null
  
)

export default component.exports